import React from 'react';

export const MainPage = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '60vh',
      }}
    >
      <img src="../../assets/images/logo_ablemen.5a905249.png" alt="Logo" />
    </div>
  );
};
